import { useTranslation } from 'react-i18next';

export function FooterSection() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">{t('footer_company_name')}</h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              {t('footer_company_name_en')}
            </p>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {t('footer_company_desc')}
            </p>
            <div className="space-y-2 text-gray-400">
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                {t('contact_address_value')}
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href={`tel:${t('contact_phone_value')}`} className="hover:text-blue-400 transition-colors cursor-pointer">
                  {t('contact_phone_value')}
                </a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href={`mailto:${t('contact_email_value')}`} className="hover:text-blue-400 transition-colors cursor-pointer">
                  {t('contact_email_value')}
                </a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer_quick_links')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#intro" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                  {t('footer_link_about')}
                </a>
              </li>
              <li>
                <a href="#business" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                  {t('footer_link_business')}
                </a>
              </li>
              <li>
                <a href="#team" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                  {t('footer_link_team')}
                </a>
              </li>
              <li>
                <a href="#achievements" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                  {t('footer_link_achievements')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                  {t('footer_link_contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Business Areas */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer_products_title')}</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">{t('footer_product_new')}</li>
              <li className="text-gray-400">{t('footer_product_resource')}</li>
              <li className="text-gray-400">{t('footer_product_used')}</li>
            </ul>
            <h4 className="text-lg font-bold mb-4 mt-6">{t('footer_regions_title')}</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">{t('footer_region_europe')}</li>
              <li className="text-gray-400">{t('footer_region_dubai')}</li>
              <li className="text-gray-400">{t('footer_region_latam')}</li>
              <li className="text-gray-400">{t('footer_region_sea')}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              {t('footer_copyright')}
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-400 text-sm transition-colors cursor-pointer"
            >
              {t('footer_powered')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
